<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Access Restricted</title>
  <style>
    :root {
      --growth-galaxy: #0048BA;
      --funding-pool: #0AC9BE;
      --bright-opportunity: #DEF6CF;
      --trust-tech: #0D2B48;
      --infinity: #FFFFFF;
      --absolute-anchor: #000000;
      --primaryColor: #00122B;
      --secondaryColor: #0040BA;
      --ternaryColor: #04C49E;
      --quaternaryColor: #B0ECDF;
      --quinaryColor: #A4C3FF;
      --senaryColor: #94B4FF;
      --primary-bg: #EEF4FF;
    }

    *,
    ::after,
    ::before {
      box-sizing: border-box;
    }

    .container {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }

    @media (min-width: 576px) {
      .container {
        max-width: 540px;
      }
    }

    @media (min-width: 768px) {
      .container {
        max-width: 720px;
      }
    }

    @media (min-width: 992px) {
      .container {
        max-width: 960px;
      }
    }

    body.accessRestrictedWrapper .card {
      position: relative;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;
      min-width: 0;
      word-wrap: break-word;
      background-color: #fff;
      background-clip: border-box;
      border: 1px solid rgba(0, 0, 0, .125);
      border-radius: .25rem;
    }

    body.accessRestrictedWrapper {
      margin: 0;
      font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
      background-color: #EEF4FF;
      color: #00122B;
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }

    body.accessRestrictedWrapper .header {
      padding: 20px 40px;
      background-color: #FFFFFF;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      font-weight: 600;
      font-size: 20px;
      color: #0040BA;
    }

    body.accessRestrictedWrapper .header .logoContainer {
      text-align: center;
    }

    body.accessRestrictedWrapper .header .logoContainer figure {
      width: 150px;
      height: auto;
      margin: 0 auto;
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    body.accessRestrictedWrapper .header .logoContainer figure svg {
      width: 100%;
      height: 50px;
    }

    body.accessRestrictedWrapper .container {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 2rem;
    }

    body.accessRestrictedWrapper .card {
      background-color: #FFFFFF;
      padding: 2rem 2.5rem;
      border-radius: 10px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      text-align: center;
      max-width: 420px;
      width: 100%;
    }

    body.accessRestrictedWrapper .icon {
      font-size: 40px;
      color: #04C49E;
      margin-bottom: 1rem;
    }

    body.accessRestrictedWrapper h1 {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 0.5rem;
    }

    body.accessRestrictedWrapper .message {
      font-size: 15px;
      color: #00122B;
      margin-bottom: 1rem;
      text-align: center;
    }

    body.accessRestrictedWrapper .error-code {
      display: inline-block;
      padding: 6px 12px;
      font-size: 13px;
      background-color: #eee;
      border-radius: 4px;
      margin-bottom: 1rem;
    }


    body.accessRestrictedWrapper .reasons {
      font-size: 14px;
      text-align: left;
      margin: 0 auto 1.5rem;
      color: #555;
      line-height: 1.6;
      max-width: 300px;
    }

    body.accessRestrictedWrapper .support {
      font-size: 14px;
      color: #00122B;
      margin-bottom: 0.5rem;
    }

    body.accessRestrictedWrapper .email {
      color: #04C49E;
      text-decoration: none;
      font-weight: 500;
      display: block;
      font-size: 1rem;
    }

    @media screen and (max-width: 767px) {
      body.accessRestrictedWrapper .email {
        font-size: 15px;
      }
    }

    body.accessRestrictedWrapper .footer {
      background: transparent linear-gradient(163deg, #001436 0%, #114596 100%) 0% 0% no-repeat padding-box !important;
      color: #ccc;
      text-align: center;
      padding: 1rem;
      font-size: 13px;
    }

    body.accessRestrictedWrapper .footer span {
      display: block;
    }

    body.accessRestrictedWrapper .footer a {
      color: #04C49E;
      text-decoration: none;
      font-weight: 500;
    }

    body.accessRestrictedWrapper .footer a figure {
      width: 112px;
      height: auto;
      margin: 0 auto;
      display: inline-block;
      vertical-align: middle;
    }

    body.accessRestrictedWrapper .footer a figure svg {
      width: 100%;
      height: auto;
    }
  </style>
</head>

<body class="accessRestrictedWrapper">
  <header class="header">
    <div class="logoContainer">
      <figure class="">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="210" height="27.501"
          viewBox="0 0 210 27.501">
          <defs>
            <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#0040ba" />
              <stop offset="1" stop-color="#04c49e" />
            </linearGradient>
            <linearGradient id="linear-gradient-2" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#a4c3ff" />
              <stop offset="1" stop-color="#04c49e" />
            </linearGradient>
          </defs>
          <g id="logo" transform="translate(-187.5 -70)">
            <rect id="R_LOGO" width="210" height="27.5" transform="translate(187.5 70)" fill="none"
              style="mix-blend-mode: normal;isolation: isolate" />
            <g id="WORDMARK" transform="translate(224.434 70)" style="mix-blend-mode: normal;isolation: isolate">
              <path id="Vector"
                d="M9.211,20.407a9.339,9.339,0,0,1-6.76-2.36A8.628,8.628,0,0,1,0,11.519V0H5.194V11.519a4.234,4.234,0,0,0,1.07,3.036A3.849,3.849,0,0,0,9.211,15.69a3.849,3.849,0,0,0,2.947-1.134,4.251,4.251,0,0,0,1.07-3.036V0h5.194V11.519a8.621,8.621,0,0,1-2.451,6.547A9.379,9.379,0,0,1,9.211,20.407Z"
                transform="translate(108.252 7.094)" fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-2" data-name="Vector"
                d="M20.522,10.022a9.644,9.644,0,0,0-2.836-7.314A10.047,10.047,0,0,0,10.465,0,10.091,10.091,0,0,0,1.5,4.751,10.67,10.67,0,0,0,0,10.458a10.416,10.416,0,0,0,2.8,7.387q2.834,3.037,8.1,3.036a14.68,14.68,0,0,0,8.768-2.742L16,15.438a11.2,11.2,0,0,1-4.879,1.092q-4.75,0-5.856-4.243H20.334l0,0A17.254,17.254,0,0,0,20.522,10.022ZM5.5,7.7A5.264,5.264,0,0,1,7.133,5.4a5.13,5.13,0,0,1,3.336-1.115A5.033,5.033,0,0,1,13.786,5.4a5.059,5.059,0,0,1,1.693,3.052H5.275l0,0A7.106,7.106,0,0,1,5.5,7.7Z"
                transform="translate(128.98 6.578)" fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-3" data-name="Vector"
                d="M11.385,0A7.874,7.874,0,0,0,7.591.913,6.049,6.049,0,0,0,5.2,3.124c-.123.21-.235.424-.339.638a.591.591,0,0,1-.531.336.634.634,0,0,1-.281-.069.6.6,0,0,1-.242-.791,11.38,11.38,0,0,1,.946-1.6c.035-.05.073-.1.108-.145A1.053,1.053,0,0,0,5.083.856V.55H0V20.48H5.194V9.8a5.233,5.233,0,0,1,1.27-3.64A4.273,4.273,0,0,1,9.8,4.751a3.907,3.907,0,0,1,3.093,1.3,5.329,5.329,0,0,1,1.143,3.64V20.476h5.194V8.3a8.033,8.033,0,0,0-2.285-6.142h.008A7.8,7.8,0,0,0,11.385,0Z"
                transform="translate(86.714 6.546)" fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-4" data-name="Vector"
                d="M14.086,17.76c-.062.019-.123.034-.185.05a.518.518,0,0,1-.154.019.587.587,0,0,1-.581-.489.606.606,0,0,1,.446-.668c.2-.053.412-.118.616-.187A7.9,7.9,0,0,0,18.322,13.4a8.561,8.561,0,0,0,1.42-4.847,8.42,8.42,0,0,0-2.393-6.069Q14.959,0,10.427,0H0V27.026H5.452V17.188H8.7l5.748,9.839h6.371l-5.506-8.8h0A1.087,1.087,0,0,0,14.086,17.76ZM5.448,12.325V5.011h4.936a3.676,3.676,0,0,1,2.743,1.024,3.546,3.546,0,0,1,1.012,2.6,3.576,3.576,0,0,1-1.085,2.67A4.418,4.418,0,0,1,9.9,12.325H5.448Z"
                fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-5" data-name="Vector"
                d="M16.063,7.249a1.069,1.069,0,0,0,.312.756c.15.149.3.306.442.466a11.639,11.639,0,0,1,.85,1.092.588.588,0,1,1-.966.672,9.973,9.973,0,0,0-.662-.867A7.879,7.879,0,0,0,9.946,6.577a9.46,9.46,0,0,0-7.11,3A10.509,10.509,0,0,0,0,17.035a10.618,10.618,0,0,0,2.836,7.5A9.361,9.361,0,0,0,9.946,27.5a7.725,7.725,0,0,0,6.218-2.918c.192-.233.373-.474.539-.718a.608.608,0,0,1,.816-.187.594.594,0,0,1,.177.825,11.109,11.109,0,0,1-.858,1.108c-.115.126-.231.248-.346.37a1.088,1.088,0,0,0-.316.76v.283h5.083V0H16.063ZM10.758,22.821a5.376,5.376,0,0,1-4.051-1.646,5.88,5.88,0,0,1-1.547-4.133,5.66,5.66,0,0,1,1.547-4.06A5.308,5.308,0,0,1,10.758,11.3a5.212,5.212,0,0,1,4.017,1.681,5.7,5.7,0,0,1,1.547,4.06,5.92,5.92,0,0,1-1.547,4.133A5.265,5.265,0,0,1,10.758,22.821Z"
                transform="translate(151.807)" fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-6" data-name="Vector"
                d="M11.539,10.889a1.078,1.078,0,0,0,0,.775l.412,1.054a.6.6,0,0,1-.269.752.6.6,0,0,1-.823-.309l-.1-.252L5.71,0H0L8.7,19.9h3.978L21.4,0h-5.71L15.7,0Z"
                transform="translate(41.9 7.091)" fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-7" data-name="Vector"
                d="M20.522,10.022a9.644,9.644,0,0,0-2.836-7.314A10.047,10.047,0,0,0,10.465,0,10.091,10.091,0,0,0,1.5,4.751,10.67,10.67,0,0,0,0,10.458a10.416,10.416,0,0,0,2.8,7.387q2.834,3.037,8.1,3.036a14.68,14.68,0,0,0,8.768-2.742L16,15.438a11.2,11.2,0,0,1-4.879,1.092q-4.75,0-5.856-4.243H20.334l0,0A17.269,17.269,0,0,0,20.522,10.022ZM5.5,7.7A5.264,5.264,0,0,1,7.133,5.4a5.13,5.13,0,0,1,3.336-1.115A5.033,5.033,0,0,1,13.786,5.4a5.059,5.059,0,0,1,1.693,3.052H5.275l0,0A7.106,7.106,0,0,1,5.5,7.7Z"
                transform="translate(63.887 6.578)" fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-8" data-name="Vector"
                d="M20.522,10.022a9.644,9.644,0,0,0-2.836-7.314A10.047,10.047,0,0,0,10.465,0,10.091,10.091,0,0,0,1.5,4.751,10.67,10.67,0,0,0,0,10.458a10.416,10.416,0,0,0,2.8,7.387q2.834,3.037,8.1,3.036a14.68,14.68,0,0,0,8.768-2.742L16,15.438a11.2,11.2,0,0,1-4.879,1.092q-4.75,0-5.856-4.243H20.334l0,0A17.269,17.269,0,0,0,20.522,10.022ZM5.5,7.7A5.264,5.264,0,0,1,7.133,5.4a5.13,5.13,0,0,1,3.336-1.115A5.033,5.033,0,0,1,13.786,5.4a5.059,5.059,0,0,1,1.693,3.052H5.275l0,0A7.1,7.1,0,0,1,5.5,7.7Z"
                transform="translate(20.811 6.578)" fill="#00122b" style="mix-blend-mode: normal;isolation: isolate" />
            </g>
            <g id="SYMBOL" transform="translate(187.5 70)" style="mix-blend-mode: normal;isolation: isolate">
              <path id="Vector-9" data-name="Vector"
                d="M8.178,17.977l-7.5-5.729A1.709,1.709,0,0,1,.36,9.838a1.738,1.738,0,0,1,2.428-.313l6.364,4.858L24.815.439a1.738,1.738,0,0,1,2.443.134A1.708,1.708,0,0,1,27.124,3l-16.737,14.9a1.739,1.739,0,0,1-2.208.084Z"
                fill="url(#linear-gradient)" style="mix-blend-mode: normal;isolation: isolate" />
              <path id="Vector-10" data-name="Vector"
                d="M1.731,27.5A1.723,1.723,0,0,1,0,25.781v-14.9a1.731,1.731,0,0,1,3.463,0V24.063H24.239V1.719a1.731,1.731,0,0,1,3.463,0V25.781A1.723,1.723,0,0,1,25.971,27.5Z"
                fill="url(#linear-gradient-2)" style="mix-blend-mode: normal;isolation: isolate" />
            </g>
            <rect id="R_LOGO-2" data-name="R_LOGO" width="210" height="27.5" transform="translate(187.5 70)" fill="none"
              style="mix-blend-mode: normal;isolation: isolate" />
          </g>
        </svg>
      </figure>
    </div>
  </header>

  <div class="container">
    <div class="card">
      <div class="icon">
        <svg width="80px" height="80px" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--twemoji"
          preserveAspectRatio="xMidYMid meet" fill="#000000">
          <g id="SVGRepo_bgCarrier" stroke-width="0" />
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
          <g id="SVGRepo_iconCarrier">
            <path fill="#04C49E" d="M33 3c-7-3-15-3-15-3S10 0 3 3C0 18 3 31 18 36c15-5 18-18 15-33z" />
            <path fill="#0040BA"
              d="M18 33.884C6.412 29.729 1.961 19.831 4.76 4.444C11.063 2.029 17.928 2 18 2c.071 0 6.958.04 13.24 2.444c2.799 15.387-1.652 25.285-13.24 29.44z" />
            <path fill="#00122B"
              d="M31.24 4.444C24.958 2.04 18.071 2 18 2v31.884c11.588-4.155 16.039-14.053 13.24-29.44z" />
          </g>
        </svg>
      </div>
      <h1>Access Restricted</h1>
      <div class="message">It looks like your request was blocked. Please try again after
        sometime.</div>
      <div class="error-code"> Error Code:
        <span>
          {{ errorCode }}
        </span>
      </div>

      <!-- <div class="message">
                <p class="m-0">
                    This could be due to unusual traffic, firewall rules, or too many requests.
                </p>
            </div> -->

      <div class="support">
        Need help? Contact us:
      </div>
      <a href="mailto:support@revenued.com" class="email" target="_blank">support&#64;revenued.com</a>
      <a href="tel:18776623489" class="email" target="_blank">+1-877-662-3489 (M-F 8am - 7pm)</a>
    </div>
  </div>

  <div class="footer">
    Protected by
    <a href="https://www.cloudflare.com/" target="_blank" rel="noopener noreferrer">
      <!-- <img src="./assets/images/logo/cloudflare.svg" alt="" width="112" height="25"> -->
      <figure>
        <svg width="239" height="54" viewBox="0 0 239 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1234_394)">
            <path
              d="M51.027 36.4346L51.405 35.1054C51.8639 33.532 51.6929 32.0671 50.928 31.0001C50.2261 30.0144 49.0562 29.4358 47.6343 29.3635L20.7268 29.0199C20.5469 29.0108 20.3939 28.9294 20.3039 28.7937C20.2139 28.6581 20.1869 28.4772 20.25 28.3054C20.3399 28.0432 20.6009 27.8353 20.8709 27.8262L48.0212 27.4826C51.243 27.3379 54.7257 24.7066 55.9496 21.5055L57.4974 17.4364C57.5424 17.3279 57.5604 17.2104 57.5604 17.0928C57.5604 17.0295 57.5514 16.9662 57.5424 16.9029C55.7966 8.95458 48.7322 3.01367 40.3 3.01367C32.5248 3.01367 25.9194 8.05937 23.5526 15.0673C22.0227 13.9189 20.0699 13.304 17.9641 13.5119C14.2295 13.8827 11.2328 16.9029 10.8638 20.6555C10.7648 21.6321 10.8458 22.5634 11.0707 23.4496C4.97834 23.6305 0.0917969 28.649 0.0917969 34.807C0.0917969 35.3676 0.136793 35.9101 0.208786 36.4527C0.244782 36.715 0.469762 36.9048 0.730737 36.9048L50.397 36.9139C50.4061 36.9139 50.4061 36.9139 50.4151 36.9139C50.6941 36.9048 50.946 36.715 51.027 36.4346Z"
              fill="#F6821F" />
            <path
              d="M59.9905 17.7363C59.7386 17.7363 59.4955 17.7454 59.2436 17.7544C59.1986 17.7544 59.1626 17.7634 59.1266 17.7815C59.0006 17.8267 58.8926 17.9352 58.8567 18.0709L57.7948 21.7421C57.3357 23.3155 57.5068 24.7803 58.2717 25.8473C58.9736 26.833 60.1435 27.4117 61.5654 27.4841L67.2979 27.8277C67.4688 27.8367 67.6129 27.9181 67.7028 28.0537C67.8018 28.1894 67.8198 28.3702 67.7658 28.5421C67.6758 28.8042 67.4148 29.0122 67.1449 29.0213L61.1874 29.3649C57.9567 29.5186 54.465 32.1409 53.2411 35.342L52.8092 36.4722C52.7282 36.6803 52.8812 36.8973 53.0881 36.9063C53.0972 36.9063 53.0972 36.9063 53.1062 36.9063H73.6153C73.8583 36.9063 74.0742 36.7435 74.1463 36.5085C74.5062 35.2334 74.6952 33.8952 74.6952 32.5027C74.6952 24.3554 68.1078 17.7363 59.9905 17.7363Z"
              fill="#FBAD41" />
            <path d="M97.3086 24.3633H100.701V33.686H106.641V36.6701H97.3086V24.3633Z" fill="white" />
            <path
              d="M110.16 30.5496V30.5134C110.16 26.9778 112.995 24.1113 116.774 24.1113C120.555 24.1113 123.353 26.9417 123.353 30.4773V30.5134C123.353 34.049 120.519 36.9155 116.739 36.9155C112.959 36.9155 110.16 34.0852 110.16 30.5496ZM119.888 30.5496V30.5134C119.888 28.7411 118.611 27.1858 116.739 27.1858C114.885 27.1858 113.643 28.6959 113.643 30.4773V30.5134C113.643 32.2857 114.921 33.841 116.774 33.841C118.647 33.841 119.888 32.331 119.888 30.5496Z"
              fill="white" />
            <path
              d="M127.51 31.2716V24.3633H130.956V31.2084C130.956 32.9807 131.847 33.8307 133.215 33.8307C134.582 33.8307 135.474 33.026 135.474 31.2989V24.3723H138.92V31.1993C138.92 35.178 136.662 36.9142 133.179 36.9142C129.696 36.8961 127.51 35.1238 127.51 31.2716Z"
              fill="white" />
            <path
              d="M144.123 24.3633H148.847C153.222 24.3633 155.759 26.8951 155.759 30.4489V30.485C155.759 34.0386 153.185 36.6791 148.775 36.6791H144.123V24.3633ZM148.902 33.6498C150.935 33.6498 152.277 32.5286 152.277 30.5392V30.5031C152.277 28.5319 150.927 27.3925 148.902 27.3925H147.516V33.6498H148.902Z"
              fill="white" />
            <path d="M160.689 24.3633H170.499V27.3473H164.092V29.4451H169.887V32.2754H164.092V36.6701H160.689V24.3633Z"
              fill="white" />
            <path d="M175.225 24.3633H178.617V33.686H184.548V36.6701H175.225V24.3633Z" fill="white" />
            <path
              d="M193.429 24.2734H196.705L201.924 36.6706H198.279L197.388 34.4734H192.664L191.791 36.6706H188.219L193.429 24.2734ZM196.399 31.8148L195.031 28.3154L193.645 31.8148H196.399Z"
              fill="white" />
            <path
              d="M206.289 24.3633H212.085C213.956 24.3633 215.253 24.8606 216.072 25.7015C216.791 26.4068 217.16 27.3563 217.16 28.568V28.6042C217.16 30.485 216.161 31.7328 214.641 32.3839L217.565 36.6791H213.642L211.175 32.9536H209.682V36.6791H206.289V24.3633ZM211.922 30.268C213.074 30.268 213.741 29.7073 213.741 28.8121V28.776C213.741 27.8084 213.038 27.3202 211.905 27.3202H209.682V30.277H211.922V30.268Z"
              fill="white" />
            <path
              d="M222.057 24.3633H231.91V27.2658H225.422V29.1286H231.298V31.8143H225.422V33.7674H232V36.6701H222.057V24.3633Z"
              fill="white" />
            <path
              d="M89.8752 31.9964C89.3982 33.0725 88.3993 33.841 87.0674 33.841C85.2137 33.841 83.9358 32.2947 83.9358 30.5134V30.4773C83.9358 28.705 85.1776 27.1858 87.0315 27.1858C88.4263 27.1858 89.4972 28.0539 89.9472 29.2294H93.5288C92.9529 26.2996 90.3972 24.1113 87.0674 24.1113C83.2879 24.1113 80.4531 26.9778 80.4531 30.5134V30.5496C80.4531 34.0852 83.2518 36.9155 87.0315 36.9155C90.2622 36.9155 92.791 34.8086 93.4569 31.9874H89.8752V31.9964Z"
              fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_1234_394">
              <rect width="231.908" height="35.9294" fill="white" transform="translate(0.0917969 2)" />
            </clipPath>
          </defs>
        </svg>
      </figure>
    </a>
    <span class="mt-2 d-block">
      &copy; 2025 Revenued | All Rights Reserved.
    </span>
  </div>

  <!-- <script defer src="./assets/js/vendors/bootstrap.min.js"></script> -->
</body>

</html>